import { useSignupState } from './useSignupState'

export const useClientProps = () => useSignupState().properties?.clientProps
